
import React from 'react';
import {Switch} from "antd";

type ToggleProps = {
    id?: string,
    on: boolean,
    disabled?: boolean,
    size?: 'small' | 'default',
    onChange: any,
    property?: string
}

const Toggle = (props: ToggleProps) => { // onChange = function () {}
    const {on, disabled, size, onChange} = props;

    return (
        <Switch
            checked={on}
            disabled={disabled}
            onChange={onChange}
            size={size}
        />
    );
}

export default Toggle;
